import type { HelpFile } from '../../types/help'
import { InboundConnectorDetailTestIds } from '../../../testids/InboundConnectorDetailTestIds'

export const inboundConnectorDetailHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorDetailTestIds.inboundConnectorDetailPage]:
      'Eingehender Konnektor — Zielsystem, Konnektortyp, Protokollkonfiguration, Zeitplan und Synchronisationsverlauf.',
    [InboundConnectorDetailTestIds.tabOverview]:
      'Überblick über den Konnektor: Zielsystem, Konnektortyp, Zeitplan und Ergebnis der letzten Synchronisation.',
    [InboundConnectorDetailTestIds.tabConfiguration]:
      'Protokollspezifische Konfiguration für diesen eingehenden Konnektor. Wechsle zwischen den Unterseiten Verbindung, Abgleich und Operationen.',
    [InboundConnectorDetailTestIds.tabSyncRuns]:
      'Aktuelle Synchronisationsläufe: Start- und Endzeiten, Datensatzzahlen und Ergebnisse.',
    [InboundConnectorDetailTestIds.btnDelete]:
      'Diesen eingehenden Konnektor löschen. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    [InboundConnectorDetailTestIds.btnTestConnection]:
      'Verbindung zum Quellsystem mit der aktuellen Konfiguration testen.',
    [InboundConnectorDetailTestIds.btnToggleEnabled]:
      'Diesen eingehenden Konnektor aktivieren oder deaktivieren. Deaktivierte Konnektoren laufen nicht nach Zeitplan.',
    [InboundConnectorDetailTestIds.deleteConfirmDialog]:
      'Löschen dieses eingehenden Konnektors bestätigen. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    [InboundConnectorDetailTestIds.detailTabs]:
      'Zwischen Übersicht, Konfiguration und Synchronisationsläufen wechseln.',
    [InboundConnectorDetailTestIds.testResultDialog]:
      'Ergebnis des Verbindungstests — Erfolg oder zugrundeliegender Fehler.',
    [InboundConnectorDetailTestIds.lastSyncCreatedCount]:
      'Anzahl der beim letzten Synchronisationslauf erstellten Datensätze.',
    [InboundConnectorDetailTestIds.lastSyncUpdatedCount]:
      'Anzahl der beim letzten Synchronisationslauf aktualisierten Datensätze.',
    [InboundConnectorDetailTestIds.lastSyncErroredCount]:
      'Anzahl der beim letzten Synchronisationslauf fehlgeschlagenen Datensätze.',
  },
}
